import { render } from "./Invoices.vue?vue&type=template&id=a18224b8"
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__